module.exports = __webpack_public_path__ + "static/images/menu.2NvHB9l.svg";